import Action from '@/components/InspectionReport/Items/Action';

export default {
    functional: true,
    props: {
        resource: {
            type: Object,
            required: true,
        },
    },
    render(h, { props, parent }) {
        const issues = props.resource.issues || [];

        if (!issues.length) {
            return null;
        }

        const title = `${parent.$t('Issues')} (${issues.length})`;

        return h('div', [
            h(
                'h2',
                { class: 'border-b-4 border-black py-2 mt-8 text-2xl font-black' },
                title,
            ),
            issues.map((item) => h(Action, {
                class: 'py-3 question',
                props: {
                    item,
                },
            })),
        ]);
    },
};
